import wizardComponent from './wizard.component';
import wizardStepComponent from './wizardStep.component';
import './wizard.less';

angular.module('rym.wizard', []).component('rymWizard', wizardComponent).component('rymWizardStep', wizardStepComponent);
